import { defineNuxtRouteMiddleware, isRedirectPredicted, trackRefererData, useSessionExpiry } from '#imports'

// First in the chain, so the referer-data POST runs alongside user/info; `tracking.global` awaits it.
export default defineNuxtRouteMiddleware((to) => {
    if (import.meta.client) return

    if (isRedirectPredicted(to)) return
    // `00.user-status` may redirect a player on their account status, which only user/info knows.
    if (useSessionExpiry().value) return

    void trackRefererData(to)
})
